export default __webpack_public_path__ + "static/media/login-background.0e440e1c.jpg";